import React, { useCallback, useContext, useMemo } from 'react';
import qs from 'qs';
import { useTranslation } from 'react-i18next';

import Link from 'components/ui/Link';
import Input from 'components/Input';
import Button from 'components/Button';
import {
  password as validatePassword,
  required,
  composeValidation,
} from 'utils/validation';
import { Form, Field } from 'react-final-form';
import { userContext } from 'contexts/UserContext';
import { useHistory } from 'react-router';
import StyledForm from './Form';
import { useSetLoginTitle } from './LoginContainer';

const validatePasswordConfirmationFactory = (message) =>
  composeValidation(validatePassword, (v, { password = '' }) =>
    v === password ? undefined : message
  );

export default function RecoveryWithCode() {
  const { t } = useTranslation('login');
  useSetLoginTitle(t('title.reset'));
  const { changePassword } = useContext(userContext);
  const history = useHistory();

  const validatePasswordConfirmation = useMemo(
    () => validatePasswordConfirmationFactory(t('message.password_mismatch')),
    [t]
  );

  const { code, login } = useMemo(
    () => qs.parse(window.location.search, { ignoreQueryPrefix: true }),
    []
  );

  const handleChangePassword = useCallback(async (data) => {
    try {
      const { password, code, login } = data;
      await changePassword(password, code, login, true);
      history.push('/');
    } catch (e) {
      console.error(e);
    }
  }, []);
  return (
    <Form
      initialValues={{ code, login }}
      onSubmit={handleChangePassword}
      render={({ handleSubmit, submitting, invalid, pristine }) => (
        <StyledForm onSubmit={handleSubmit}>
          <Field
            name="code"
            validate={required}
            render={({ input, meta }) => (
              <Input
                label={t('fields.code')}
                type="number"
                required
                error={meta.touched && meta.error}
                {...input}
              />
            )}
          />
          {login ? null : (
            <Field
              name="login"
              validate={required}
              render={({ input, meta }) => (
                <Input
                  label={t('fields.login')}
                  required
                  error={meta.touched && meta.error}
                  {...input}
                />
              )}
            />
          )}
          <Field
            name="password"
            validate={validatePassword}
            render={({ input, meta }) => (
              <Input
                label={t('fields.password')}
                type="password"
                autoComplete="new-password"
                required
                {...input}
                error={meta.touched && meta.error}
              />
            )}
          />
          <Field
            name="passwordConfirmation"
            validate={validatePasswordConfirmation}
            render={({ input, meta }) => (
              <Input
                label={t('fields.password_confirmation')}
                type="password"
                autoComplete="new-password-confirm"
                required
                {...input}
                error={meta.touched && meta.error}
              />
            )}
          />
          <Button type="submit" disabled={invalid || pristine || submitting}>
            {t('actions.login')}
          </Button>
          <Link to="/recovery">{t("i_haven't_code")}</Link>
        </StyledForm>
      )}
    />
  );
}
